import styled from 'styled-components'

export const FooterWrapper = styled.div`
  .footer {
    padding: 25px 20px;
    font-size: 0.625rem;
    background: #000000;
    color: #ffffff;
    text-align: left;
    display: flex;
    align-items: center;
    justify-content: space-between;
    line-height: 1.3;
    letter-spacing: 0.8px;
    .brandLogo {
      margin-top: 0px;
      height: 20px;
      width: auto;
    }
    .footer-links {
      a {
        color: #ffffff;
        padding: 8px;
        text-decoration: none;
        font-size: 12px;
        :hover {
          text-decoration: underline;
        }
      }
    }
  }
`
